var map = {
	"./de_DE.json": 1140,
	"./en_AU.json": 1141,
	"./en_GB.json": 1142,
	"./en_US.json": 1143,
	"./es_AR.json": 1144,
	"./es_ES.json": 1145,
	"./es_MX.json": 1146,
	"./fr_CA.json": 1147,
	"./fr_FR.json": 1148,
	"./it_IT.json": 1149,
	"./nl_NL.json": 1150,
	"./pt_BR.json": 1151,
	"./pt_PT.json": 1152,
	"./sv.json": 1153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1139;